// src/store/modules/home.js
import { getMyInfo } from "@api/home";
const state = {
    userinfo: {} // 初始数据
};

const getters = {
    userinfo: (state) => state.datalist // 返回数据列表
};

const mutations = {
    setDatalist(state, data) {

        state.userinfo = data; // 更新数据列表
    }
};

const actions = {
    async setchDatalist({ commit }) {
        try {
            // 调用 API 函数获取数据
            const response = await getMyInfo(); // 假设这个函数返回一个 Promise
            const data = response.data; // 假设返回的数据在 response.data 中

            commit('setDatalist', data); // 提交 mutation 更新状态
        } catch (error) {
            console.error('获取数据失败:', error); // 处理错误
        }
    }
};

export default {
    namespaced: true, // 确保模块是命名空间的
    state,
    getters,
    mutations,
    actions
};